import { defineMessages } from 'react-intl';

export default defineMessages({
  reopenTransfer: {
    id: 'sentinel.components.reopenTransferForm.reopenTransfer',
    defaultMessage: 'Reopen Rejected Transfer',
  },
  comment: {
    id: 'sentinel.components.reopenTransferForm.comment',
    defaultMessage: 'Comment',
  },
  confirmWarning: {
    id: 'sentinel.components.reopenTransferForm.confirmWarning',
    defaultMessage: 'WARNING: Reopening this transfer will immediately set the state of this item to Approved. Exception: wire deposits will go back to ReviewPending if still missing wire details.',
  },
  submit: {
    id: 'sentinel.components.reopenTransferForm.submit',
    defaultMessage: 'Approve and Reopen',
  },
});



// WEBPACK FOOTER //
// ./src/components/ReopenTransferForm/messages.js